const credentials = {
    access_token: {label: "Access Token", type: "password"},
    admin_account: {label: "Admin Account", type: "input"},
    apikey: {label: "API Key", type: "password"},
    apikeys: {label: "API Keys", type: "apikeys"},
    client_id: {label: "Client ID", type: "password"},
    client_secret: {label: "Client Secret", type: "password"},
    consumer_key: {label: "Consumer Key", type: "password"},
    consumer_secret: {label: "Consumer Secret", type: "password"},
    cookie: {label: "Cookie", type: "password", multiline: true},
    credentials: {label: "Credentials", type: "password", multiline: true},
    database: {label: "Database", type: "input"},
    delegate_account: {label: "Delegate Account", type: "input"},
    domain: {label: "Domain", type: "input"},
    folder: {label: "Folder", type: "input"},
    organizationId: {label: "Organization ID", type: "input"},
    organization_id: {label: "Organization ID", type: "input"},
    password: {label: "Password", type: "password"},
    port: {label: "Port", type: "input"},
    pwd: {label: "Password", type: "password"},
    redirect_uri: {label: "Redirect URI", type: "input"},
    refresh_token: {label: "Refresh Token", type: "password"},
    schema: {label: "Default Schema (Optional)", type: "input"},
    security_token: {label: "API Token", type: "password"},
    service_account: {label: "Service Account", type: "input"},
    server: {label: "Host", type: "input"},
    sitename: {label: "Site Name", type: "input"},
    subdomain: {label: "Subdomain", type: "input"},
    tenant_id: {label: "Tenant ID", type: "password"},
    token: {label: "API Token", type: "password"},
    url: {label: "URL", type: "input"},
    url_auth: {label: "URL (Authentication)", type: "input"},
    url_data: {label: "URL (Data)", type: "input"},
    username: {label: "Username", type: "input"},
}
export default credentials;